import React from 'react';
import { ChevronRight } from 'lucide-react';
import { imagineFeatures } from '../data/mockData';
import { useScrollReveal } from '../hooks/useScrollReveal';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const JustImagineSection = () => {
  const [sectionRef, isSectionVisible] = useScrollReveal();

  return (
    <section className="py-24 lg:py-32 bg-white" id="sectors">
      <div
        ref={sectionRef}
        className={`section-container reveal ${isSectionVisible ? 'visible' : ''}`}
      >
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Image Side */}
          <div className="relative group">
            <div className="overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="/print-shop-quality-control.webp"
                alt="Print Shop Worker Checking Quality - Imprint Controlling Printing Process"
                className="w-full h-[400px] lg:h-[550px] object-cover transition-transform duration-700 group-hover:scale-105"
              />
              {/* Overlay text */}
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black/80 to-transparent">
                <h2
                  className="text-4xl lg:text-5xl font-bold text-white leading-tight"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  Just<br />Imagine
                </h2>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-[#00BCE4] rounded-xl -z-10"></div>
          </div>

          {/* Content Side with Accordion */}
          <div className="lg:pt-8">
            <Accordion type="single" collapsible className="space-y-3">
              {imagineFeatures.map((feature, index) => (
                <AccordionItem
                  key={feature.title}
                  value={`item-${index}`}
                  className="border border-gray-200 rounded-xl px-6 hover:border-[#00BCE4]/30 transition-colors duration-300 data-[state=open]:border-[#00BCE4]/50 data-[state=open]:shadow-lg data-[state=open]:shadow-[#00BCE4]/5"
                >
                  <AccordionTrigger className="py-5 hover:no-underline group">
                    <div className="flex items-start gap-4 text-left">
                      <ChevronRight
                        size={20}
                        className="text-[#00BCE4] flex-shrink-0 mt-0.5"
                      />
                      <div>
                        <h4
                          className="text-base font-semibold text-gray-900 group-hover:text-[#00BCE4] transition-colors duration-300"
                          style={{ fontFamily: 'Outfit, sans-serif' }}
                        >
                          {feature.title}
                        </h4>
                        <p
                          className="text-sm text-gray-500 mt-1 leading-relaxed"
                          style={{ fontFamily: 'Inter, sans-serif' }}
                        >
                          {feature.summary}
                        </p>
                      </div>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 pl-10">
                    <p
                      className="text-sm text-gray-600 leading-relaxed"
                      style={{ fontFamily: 'Inter, sans-serif' }}
                    >
                      {feature.details}
                    </p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            <div className="mt-8 p-6 rounded-xl bg-gradient-to-r from-[#00BCE4]/5 to-transparent border-l-4 border-[#00BCE4]">
              <p
                className="text-lg font-semibold text-[#00BCE4] leading-relaxed"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                The dream can become a reality by talking to Imprint and letting us configure your solution.
              </p>
            </div>

            <div className="mt-6">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="btn-primary text-xs"
              >
                Tell Me More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JustImagineSection;
